import { render, staticRenderFns } from "./VersionDelete.vue?vue&type=template&id=aec6f6b6&lang=pug"
import script from "./VersionDelete.vue?vue&type=script&lang=js"
export * from "./VersionDelete.vue?vue&type=script&lang=js"
import style0 from "./VersionDelete.vue?vue&type=style&index=0&id=aec6f6b6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports